import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date): string {
    const year = date.getFullYear();
    const month = this._2Digit(date.getMonth() + 1);
    const day = this._2Digit(date.getDate());

    // fallback (for month/year label, etc.)
    return `${year}/${month}/${day}`;
  }

  private _2Digit(n: number): string {
    return ('00' + n).slice(-2);
  }
}

export function dateFormatter(input: string | Date): Date {
  if (input instanceof Date) {
    if (isNaN(input.getTime())) {
      throw new Error('Invalid Date object');
    }
    return input;
  }

  const year = parseInt(input.substring(0, 4), 10);
  const month = parseInt(input.substring(4, 6), 10) - 1;

  const day = parseInt(input.substring(6, 8), 10);
  const date = new Date(year, month, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month ||
    date.getDate() !== day
  ) {
    throw new Error('Invalid date string: out-of-range date');
  }

  return date;
}
